import { c as _c } from "react/compiler-runtime";
import { PopularityEvent, PopularityEventData } from '@spa/generated/graphql/graphql';
import { SendPopularityEventsResult } from '@spa/lib/graphql/search/sendPopularityEvents';
import sendPopularityEventsAction from '@spa/lib/actions/popularityEvents/sendPopularityEventsAction';
import { useCallback } from 'react';
export interface UsePopularityEventsAPIResult {
  readonly sendCartAdditionEvent: (eventData: PopularityEventData) => Promise<SendPopularityEventsResult>;
  readonly sendClickEvent: (eventData: PopularityEventData) => Promise<SendPopularityEventsResult>;
  readonly sendPurchaseEvents: (eventData: ReadonlyArray<PopularityEventData>) => Promise<SendPopularityEventsResult>;
}
export function usePopularityEventsAPI() {
  const $ = _c(4);
  const performRequest = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = async eventData => {
      const event = {
        type: "click",
        name: "products_cart_addition_event",
        data: eventData
      };
      return performRequest([event]);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const sendCartAdditionEvent = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async eventData_0 => {
      const event_0 = {
        type: "click",
        name: "products_click_event",
        data: eventData_0
      };
      return performRequest([event_0]);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sendClickEvent = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = async eventData_1 => {
      const events_0 = eventData_1.map(_temp2);
      return performRequest(events_0);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const sendPurchaseEvents = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      sendCartAdditionEvent,
      sendClickEvent,
      sendPurchaseEvents
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp2(data) {
  return {
    type: "conversion",
    name: "products_purchase_event",
    data
  };
}
async function _temp(events) {
  return await sendPopularityEventsAction("sendPopularityEventsAction", events);
}